
<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$router.replace({
        path: from.path,
        query: {
          id: to.query.id
        }
      })
    })
  }
}
</script>